var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useApprovalWorkflow } from 'app/domains/approval';
import { GetLastApprovalRequestQuery } from 'app/domains/approval/hooks/useLastApprovalRequest';
import { APPROVAL_IGNORE_CODES } from 'app/domains/esigning/utils';
import { MUTATION } from './mutation';
export const useCancelApprovalRequest = () => {
    const { approvalRequestId } = useApprovalWorkflow();
    const { addToast } = useToast();
    const [mutate] = useMutation(MUTATION);
    const cancelApprovalRequest = (message) => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate({
            variables: { approvalId: approvalRequestId || '', input: { cancellationMessage: message } },
            refetchQueries: [GetLastApprovalRequestQuery],
            context: {
                sentry: {
                    ignore: APPROVAL_IGNORE_CODES,
                },
            },
        });
        addToast({
            appearance: 'success',
            title: t({
                comment: 'Cancel approval request success message',
                message: 'Approval request has been cancelled',
            }),
        });
    });
    return { cancelApprovalRequest };
};
